<template>
  <div v-show='cpntMostrar'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <div v-else-if='cpntStatus === ""'>
      <div class="rf-select-options-copiar" style='width: 60%; display: inline-block;'>
        <RF-Select2 style='margin-bottom: 0px; width: 100%;'
          :cpntStatus='cpntStatus'
          :cpntId='cpntId'
          :cpntClassDivField='cpntClassDivField'
          :cpntNome='cpntNome'
          :cpntValue='value'
          :cpntOptions='options'
          :cpntKeyValue='cpntKeyValue'
          :cpntKeyMostra='cpntKeyMostra'
          :cpntDisabled='cpntDisabled'
          :cpntMostrar='cpntMostrar'
          :cpntMensagem='cpntMensagem'
          :cpntOptionInicialNome='cpntOptionInicialNome'
          :cpntOptionInicialValue='cpntOptionInicialValue'
          :cpntMensagemTipo='cpntMensagemTipo'
          :cpntAddOption='cpntAddOption'
          :cpntMultiple='cpntMultiple'
          :cpntExplica='cpntExplica'

          :cpntOnChange='onChangeValue'
        ></RF-Select2>
      </div>

      <div class="rf-bt-copiar" style='width: 30%; display: inline-block; margin-left: 5px;'>
        <!-- <template v-if='cpntExplica !== ""'>
          <RF-Explica 
            :cpntId='cpntId + "-qtip-explica"' 
            :cpntTitle='cpntExplica'
          ></RF-Explica>
        </template> -->
        <RF-Button style='vertical-align: -5px;'
          :cpntId='cpntId + "-bt-copiar"'
          :cpntStatus='""' 
          :cpntTipo='"copiar"'
          :cpntClass='[ "btn", "btn-default", "btn-sm" ]'

          @onClickButton='onCopiarInformacao'
        ></RF-Button>
      </div>
      
      <div style='display: block; width: 100%;' v-if='Object.keys(optionSelected).length >= 1 && cpntKeyResultado.length >= 1'>
        <span v-for='(key, index) in cpntKeyResultado' :key="index">
          <span v-if='optionSelected.hasOwnProperty(key)' v-html='optionSelected[key]'></span>
          <span v-else v-html='key'></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntNome: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 'Códigos RF'
        }
      },
      cpntValue: {
        required: false,
        validator: function (val) {
          return ([ 'string', 'number', 'object' ].indexOf(typeof val) !== -1)
        },
        default: function () {
          return ''
        }
      },
      cpntKeyValue: {
        type: String,
        required: false,
        default: function () {
          return 'id'
        }
      },
      cpntKeyMostra: {
        type: Array,
        required: false,
        default: function () {
          return [ 'id' ]
        }
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false,
        default: function () {
          return { mensagem: 'Copie e cole o código desejado nos conteúdos abaixo e o sistema o substituirá quando enviar o e-mail.' }
        }
      },
      cpntAddOption: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntOptionInicialNome: {
        type: String,
        required: false,
        default: function () {
          return 'Selecione'
        }
      },
      cpntOptionInicialValue: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntMultiple: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntFocus: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntKeyResultado: {
        type: Array,
        required: false,
        default: function () {
          return [ 'descricao' ]
        }
      },
      cpntRouter: {
        type: String,
        required: true
      }
    },
    data: function () {
      return {
        optionSelected: {},
        options: [],
        value: this.cpntValue
      }
    },
    mounted: function () {
      this.iniciar()
    },
    methods: {
      iniciar: function () {
        var self = this

        // LIMPA OS OPTIONS EXISTENTES
        self.options = []

        if (self.cpntRouter !== '') {
          // BUSCAS OS CODIGOS RF QUE PODEM SER UTILIZADOS
          self.$store.state.comunicaAPI(self.cpntRouter, 'GET', null, function (apiSuccess) {
            // CONVERTE OS VALORES RECEBIDOS PARA O VALOR CORRETO
            for (var key in apiSuccess.data) {
              self.options.push({ id: key, descricao: apiSuccess.data[key] })
            }

            // SETA O STATUS PARA O FORMULARIO
            self.statusGeral = ''
          }, function (apiError) {
            // SETA O ERRO RECEBIDO
            self.statusGeral = apiError

            // SETA A NOVA DATA PARA FORÇAR A ATUALIZAÇÃO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        } else {
          // SETA O STATUS PARA O FORMULARIO
          self.statusGeral = ''
        }
      },
      onChangeValue: function (value) {
        var self = this

        // SETA O VALOR SELECIONADO
        self.value = value

        // PEGA QUAL FOI O OPTION SELECIONADO
        var option = self.options.filter(item => item[self.cpntKeyValue] === value)

        // SETA O VALOR DO OPTION SELECIONADO
        self.optionSelected = option.length >= 1 ? option[0] : {}
      },
      onCopiarInformacao: function () {
        var self = this

        if (Object.keys(self.optionSelected).length >= 1) {
          var $temp = $('<input>')
          $('body').append($temp)
          $temp.val(self.optionSelected[self.cpntKeyValue]).select()
          document.execCommand('copy')

          self.$store.state.msgWarn('Código [ ' + self.optionSelected[self.cpntKeyValue] + ' ] copiado para a área de transferência.', 'success')

          setTimeout(function () {
            if (self.optionSelected[self.cpntKeyValue] === $temp.val()) {
              // LIMPA O OPTION SELECIONADO
              self.optionSelected = {}

              // LIMPA O VALOR SELECIONADO
              self.value = ''
            }

            // REMOVE O VALOR SALVO
            $temp.remove()
          }, 3000)
        } else {
          self.$store.state.msgWarn('Nenhum código selecionado para copiar.', 'warning')
        }
      }
    },
    watch: {
      'cpntRouter': function () {
        this.iniciar()
      }
    }
  }
</script>
